export { Gallery as default } from './Gallery';
